import type { ClassAnalyticsProperties } from '@engage/classes';
import { toClassAnalytics } from '@engage/classes';
import type { DetailedWorkout } from '@engage/workouts';
import { toAnalyticsWorkoutProperties } from '@engage/workouts';
import { toBaseProperties } from '@members/analytics/webBaseProperties';

export const trackDisplayedEarlyExitFeedback = (
  classAnalyticsDetails: ClassAnalyticsProperties | undefined,
  workoutInfo: DetailedWorkout | undefined,
  percentCompleted: number,
) => {
  if (workoutInfo) {
    return {
      event: 'Displayed Early Exit Feedback Prompt',
      ...toBaseProperties(),
      ...toClassAnalytics(classAnalyticsDetails),
      ...toAnalyticsWorkoutProperties(workoutInfo),
      '[% Workout Completed]': percentCompleted,
    };
  } else
    return {
      event: 'Displayed Early Exit Feedback Prompt',
      ...toBaseProperties(),
      ...toClassAnalytics(classAnalyticsDetails),
      '[% Workout Completed]': percentCompleted,
    };
};

export const trackViewedEarlyExitFeedbackSurvey = (
  classAnalyticsDetails: ClassAnalyticsProperties | undefined,
  workoutInfo: DetailedWorkout | undefined,
  percentCompleted: number,
) => {
  if (workoutInfo) {
    return {
      event: 'Viewed Early Exit Feedback Prompt',
      ...toBaseProperties(),
      ...toClassAnalytics(classAnalyticsDetails),
      ...toAnalyticsWorkoutProperties(workoutInfo),
      '[% Workout Completed]': percentCompleted,
    };
  } else
    return {
      event: 'Viewed Early Exit Feedback Prompt',
      ...toBaseProperties(),
      ...toClassAnalytics(classAnalyticsDetails),
      '[% Workout Completed]': percentCompleted,
    };
};

export const trackSubmittedEarlyExitFeedbackSurvey = (
  classAnalyticsDetails: ClassAnalyticsProperties | undefined,
  workoutInfo: DetailedWorkout | undefined,
  percentCompleted: number,
  earlyExitReason: any,
) => {
  if (workoutInfo) {
    return {
      event: 'Submitted Early Exit Feedback Survey',
      ...toBaseProperties(),
      ...toClassAnalytics(classAnalyticsDetails),
      ...toAnalyticsWorkoutProperties(workoutInfo),
      '[% Workout Completed]': percentCompleted,
      '[Early Exit Reason]': earlyExitReason,
    };
  } else
    return {
      event: 'Submitted Early Exit Feedback Survey',
      ...toBaseProperties(),
      ...toClassAnalytics(classAnalyticsDetails),
      '[% Workout Completed]': percentCompleted,
      '[Early Exit Reason]': earlyExitReason,
    };
};

export const trackPausedClassPreview = (
  classAnalyticsDetails: ClassAnalyticsProperties | undefined,
  percentCompleted: number,
) => {
  return {
    event: 'Paused Class Preview',
    source: 'Class Details',
    ...toBaseProperties(),
    ...toClassAnalytics(classAnalyticsDetails),
    '[Source Details]': 'Autoplay',
    '[% Preview Completed]': percentCompleted,
  };
};

export const trackPreviewedClass = (
  source: string,
  classAnalyticsDetails: ClassAnalyticsProperties | undefined,
  percentCompleted: number,
) => {
  return {
    event: 'Previewed Class',
    source: source,
    ...toBaseProperties(),
    ...toClassAnalytics(classAnalyticsDetails),
    '[Source Details]': 'Autoplay',
    '[% Preview Completed]': percentCompleted,
  };
};
